import { trackClientEvent } from '../../../../trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey = 'zip_code_protection-view_blocked_pdp_page-view';

/**
 * record the action of users viewing the Faire Protection restricted pdp page
 */
export function trackZipCodeProtectionViewBlockedPdpPageView(
  brandToken: string,
  productToken: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { brandToken, productToken },
  });
}
